import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { CmsConfig, I18nModule, provideConfig } from '@spartacus/core'
import { IconModule, SupplementHashAnchorsModule } from '@spartacus/storefront'
import { CustomAnnouncementBannerComponent } from './custom-announcement-banner.component'

@NgModule({
  declarations: [CustomAnnouncementBannerComponent],
  imports: [CommonModule, IconModule, I18nModule, SupplementHashAnchorsModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        B2BAnnouncementBannerComponent: {
          component: CustomAnnouncementBannerComponent
        }
      }
    })
  ],
  exports: [CustomAnnouncementBannerComponent]
})
export class CustomAnnouncementBannerModule {}
